import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './login.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({ email: '', password: '' });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  
  const { signIn, signUp, signInWithProvider, signInWithInstagram, signInWithLine, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const togglePassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = { email: '', password: '', phone: '' };

    if (!email.trim()) newErrors.email = 'この項目は入力必須です';
    if (!password.trim()) newErrors.password = 'この項目は入力必須です';
    if (isSignUp && !phone.trim()) newErrors.phone = 'この項目は入力必須です';
    if (isSignUp && phone.trim() && !/^0[0-9]{9,10}$/.test(phone.trim())) {
      newErrors.phone = '正しい電話番号形式で入力してください（例: 09012345678）';
    }

    setErrors(newErrors);

    if (!newErrors.email && !newErrors.password && !newErrors.phone) {
      setLoading(true);
      setError('');

      try {
        let result;
        if (isSignUp) {
          result = await signUp(email, password, phone);
          if (!result.error) {
            setError('確認メールを送信しました。メールを確認してアカウントを有効化してください。');
            setIsSignUp(false);
          }
        } else {
          result = await signIn(email, password);
          if (!result.error) {
            navigate('/dashboard');
          }
        }
        
        if (result.error) {
          setError(result.error.message);
        }
      } catch (err) {
        setError('エラーが発生しました。もう一度お試しください。');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSocialSignIn = async (provider) => {
    try {
      if (provider === 'instagram') {
        await signInWithInstagram();
      } else if (provider === 'line') {
        await signInWithLine();
      } else {
        const { error } = await signInWithProvider(provider);
        if (error) {
          setError(error.message);
        }
      }
    } catch (err) {
      setError('ソーシャルログインでエラーが発生しました。');
    }
  }; 

  return (
    <div className="page-wrapper">
      <div className="background"></div>
      <div className="logo">
        <h1><img src="/logo.png" alt="logo" /></h1>
      </div>
      <div className="login-container">
        <div className="login-box">
          <h2>{isSignUp ? '会員登録' : 'ログイン'}</h2>
          {/* <div className="google-login">
            <button type="button" onClick={() => handleSocialSignIn('google')} className="social-btn"><img src="/google-login.png" alt="Google" /></button>
          </div> */}
          <div className="social-icons">
            <button type="button" onClick={() => handleSocialSignIn('google')} className="social-btn"><img src="/Google.png" alt="Google" /></button>
            <button type="button" onClick={() => handleSocialSignIn('twitter')} className="social-btn"><img src="/X.png" alt="X" /></button>
            <button type="button" onClick={() => handleSocialSignIn('instagram')} className="social-btn"><img src="/Instagram.png" alt="Instagram" /></button>
            <button type="button" onClick={() => handleSocialSignIn('facebook')} className="social-btn"><img src="/Facebook.png" alt="Facebook" /></button>
            <button type="button" onClick={() => handleSocialSignIn('line')} className="social-btn"><img src="/LINE.png" alt="LINE" /></button>
          </div>
        </div>

        <form className="form-box" onSubmit={handleSubmit}>
          {error && <div className="error-message" style={{ color: '#ff4444', marginBottom: '15px', fontSize: '14px' }}>{error}</div>}
          
          {isSignUp && (
            <>
              {errors.phone && <p className="error-message">{errors.phone}</p>}
              <input
                type="tel"
                placeholder="Phone number（例: 09012345678）"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </>
          )}

          {errors.email && <p className="error-message">{errors.email}</p>}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />


          {errors.password && <p className="error-message">{errors.password}</p>}
          <div className="password-wrapper">
            <input
              type={passwordVisible ? 'text' : 'password'}
              id="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="button" className="toggle-password" onClick={togglePassword}>
              <i className={`fa-solid ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}></i>
            </button>
          </div>

          <label className="remember-switch">
            <input type="checkbox" />
            <span className="slider"></span>
            ログイン情報を保存する
          </label>

          <button className="signin-btn" type="submit" disabled={loading}>
            {loading ? '処理中...' : (isSignUp ? 'アカウント作成' : 'サインイン')}
          </button>
          
          <p className="register-link">
            {isSignUp ? 'ログインはこちらから' : '会員登録はこちらから'}
            <button 
              type="button" 
              onClick={() => setIsSignUp(!isSignUp)}
              style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
            >
              {isSignUp ? 'ログインに戻る' : 'アカウントを作成'}
            </button>
          </p>

          {isSignUp && (
            <div style={{ marginTop: '15px', padding: '15px', background: '#f8f9fa', borderRadius: '5px', border: '1px solid #e9ecef' }}>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>アカウント作成</h3>
              <p style={{ margin: '0', fontSize: '14px', color: '#666' }}>
                上記のフォームにメールアドレスとパスワードを入力し、「アカウント作成」ボタンを押すとアカウントが作成されます。
              </p>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;